import { enumToNameWithDefault, rawValueToEnumWithDefault } from '@ps-smart-cp/ppfw-client';
import { orderItemNameConfig } from './OrderItem.name';

enum OrderItem {
  code = '1',
  name = '2',
  spareNameOne = '3',
  spareNameTwo = '4',
}

const orderItemMap = new Map([
  ['1', OrderItem.code],
  ['2', OrderItem.name],
  ['3', OrderItem.spareNameOne],
  ['4', OrderItem.spareNameTwo],
]);

const rawValueToOrderItem = rawValueToEnumWithDefault(orderItemMap, OrderItem.code);

const orderItemToDisplay = enumToNameWithDefault(OrderItem, orderItemNameConfig);

const orderItemToDisplayWithPrefix = enumToNameWithDefault(OrderItem, orderItemNameConfig, true);

export { OrderItem, orderItemToDisplay, orderItemToDisplayWithPrefix, rawValueToOrderItem };
